<template>
  <div class="mx-auto" style="width: 80%" >



    <b-row>
      <b-col style="margin-bottom: 10px">
      <div class="d-flex justify-content-end" >
        <!-- <b-button variant="info"  style="margin-right: 10px" v-if="isAdmin">Admin</b-button>  -->
		<CreateTestuser />
		<EditTestuser :users="selectedUsers" />
		<b-button variant="danger" style="margin-right: 10px" @click="deleteSelectedTestUsers">Delete Selected</b-button>
        <b-button variant="danger" style="margin-right: 10px" @click="deleteAllTestusers">Delete All</b-button>
        <b-button variant="info" style="margin-right: 10px" v-b-toggle.help-collapse>Help</b-button>
      </div>
    </b-col> 
    </b-row>
    <b-row>
      <b-collapse id="help-collapse">
        <b-card  class="mx-auto" style="width: 97%" align="left">
        <p>Test users created through IAM Testuser Builder will be present in DEV and QA OpenLDAP. You may add them to groups in grouper DEV or QA. If your application is pointed at QA shibboleth in its lower environments, you can use these to log-in to your application.</p>

        <p>By default, a test user's password is set to your own directory ID password.</p>
      </b-card>
      </b-collapse>
    </b-row>
    <b-row>
      <b-col md="10" lg="12" class="text-center">


      <b-table ref="userTable" bordered class="text-center" selected-variant='info' selectable select-mode='multi' striped hover @row-selected="rowsSelected" :items="testusers" :fields="testuserFields">
		
        <template v-slot:cell(view)="row">
          <b-button size="sm" @click="viewTestUser(row.item)" variant="info" class="mr-2">View</b-button>
        </template>
		
      </b-table>


      </b-col>
    </b-row>

    <ViewTestuser :user='viewUser' :showuser='showTestuserDetails' />
     

  </div>

</template>

<script>
/* eslint-disable no-alert, no-console, no-unused-vars */

// import {FETCH_CAS_TICKET, FETCH_JWT} from '../../store/actions/auth'
import {CREATE_TEST_USER, UPDATE_TEST_USER, DELETE_TEST_USER} from '../../store/actions/testusers'
import CreateTestuser from './CreateTestuser'
import EditTestuser from './EditTestuser'
import ViewTestuser from './ViewTestuser'

  // FETCH_JWT,
  // ON_SUCCESSFUL_AUTHORIZATION,
  // NOTIFY_AUTH_FAILURE,
  // LOGOUT} 


export default {
  name: 'TestuserBuilderList',
  components: {
    CreateTestuser,
    ViewTestuser,
	EditTestuser
  },
  data() {
    return {
      viewUser: {},
      selectedUsers: [],
      showTestuserDetails: false
    }

  },
  computed: {
    user() {
      return this.$store.getters.jwtSubject
    },
    testuserFields() {
      let baseFields = [
        {key: 'ldap.uid', sortable: true, label: 'Directory ID'},
        {key: 'ldap.cn', sortable: true, label: 'Name'},
        {key: 'ldap.umStudent', sortable: true, label: 'Student'},
        {key: 'ldap.umEmployee', sortable: true, label: 'Employee'}
        ]
      if(this.scopes.includes("testuser.create.sis")) {
        baseFields.push({
          key: "isSis", sortable: true, label: 'In SIS?'
        })
      }

      if(this.scopes.includes("testuser.create.ups")) {
        baseFields.push({
          key: "isUps", sortable: true, label: 'In UPS?'
        })
      }
      baseFields.push({key: 'view', label: "Details"})
      return baseFields
      
    },
    scopes() {
      return this.$store.getters.jwtData.scope ?? []
    },
    isAdmin() {
      return this.$store.getters.jwtData.scope.includes('testuser.admin')
    }
  },
  props: {
    testusers: Array
  },


  
  created: function() {
    //states:
    // logged out
    // has cas ticket
    // authorized
    // unauthorized
    //check for cas ticket
    

  },
  mounted: function() {
    this.$root.$on('bv::modal::hide', function (bvEvent, modalId)  {
      console.log(bvEvent, modalId)
    })
  },
  methods: {
    createTestuser() {
      this.$store.dispatch(CREATE_TEST_USER)

      // this.$store.commit('increment')
    },
	
	//editAllTestusers() {
		// TODO probably best to batch this up if possible
	//},
	//editTestUser(ldapUser) {
	//	console.log("EDIT" + ldapUser)
	//	this.$store.dispatch(UPDATE_TEST_USER, ldapUser)
	//},
	//editSelectedTestUsers() {
    //  console.log("EDITING" + this.selectedUsers)
    //  this.selectedUsers.map((testuser) =>
    //  this.$store.dispatch(UPDATE_TEST_USER, testuser))
	//}
	
	deleteSelectedTestUsers(selectedUsers) {
		this.selectedUsers.map((testuser) =>
		this.$store.dispatch(DELETE_TEST_USER, testuser))
	},
    deleteAllTestusers() {
		// TODO probably best to batch this up if possible
      this.$store.getters.testusers.map((testuser) => this.$store.dispatch(DELETE_TEST_USER, testuser))
    },
    deleteTestUser(ldapUser) {
      console.log("DELETE" + ldapUser)
      this.$store.dispatch(DELETE_TEST_USER, ldapUser)
    },
    //rowSelected(selectedUsers) {
      // this.$store.commit(SHOW_TEST_USER_DETAILS, selectedUsers[0])
      //if(selectedUsers.length > 0) {
        //this.selectedUser = selectedUsers[0]
        //this.showTestuserDetails = true
        //this.$bvModal.show('view-testuser-modal')

      //}      
    //}
	viewTestUser(ldapUser) {
		this.viewUser = ldapUser;
		this.showTestUserDetails = true
		this.$bvModal.show('view-testuser-modal')
	},
	rowsSelected(selectedUsers) {
		this.selectedUsers = selectedUsers
	}

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
